import { deepMerge } from '../../utils';
import { TypographyBaseFontSize, TypographyBaseLineHeight, TypographyFamilyBodyFontFamily, TypographyFamilyBodyFontWeightBold, TypographyFamilyBodyFontWeightDefault, TypographyFamilyBodyFontWeightSemiBold, TypographyFamilyCaptionFontFamily, TypographyFamilyCaptionFontWeightBold, TypographyFamilyCaptionFontWeightDefault, TypographyFamilyCaptionFontWeightSemiBold, TypographyFamilyHeadingFontFamily, TypographyFamilyHeadingFontWeightDefault, TypographyFamilyHeroFontFamily, TypographyFamilyHeroFontWeightDefault, TypographyFamilyPriceFontFamily, TypographyFamilyPriceFontWeightDefault, TypographyLineHeightL, TypographyLineHeightM, TypographyLineHeightS, TypographyLineHeightXs } from '../../design-tokens/honeycomb-tokens';
const defaultLineHeights = {
  xs: TypographyLineHeightXs,
  s: TypographyLineHeightS,
  m: TypographyLineHeightM,
  l: TypographyLineHeightL
}; // Families

const defaultFamilyBody = {
  fontFamily: TypographyFamilyBodyFontFamily,
  fontWeight: {
    default: TypographyFamilyBodyFontWeightDefault,
    regular: TypographyFamilyBodyFontWeightDefault,
    semiBold: TypographyFamilyBodyFontWeightSemiBold,
    bold: TypographyFamilyBodyFontWeightBold
  },
  textTransform: 'none'
};
const defaultFamilyHeading = {
  fontFamily: TypographyFamilyHeadingFontFamily,
  fontWeight: {
    default: TypographyFamilyHeadingFontWeightDefault
  },
  textTransform: 'none'
};
const defaultFamilyHero = {
  fontFamily: TypographyFamilyHeroFontFamily,
  fontWeight: {
    default: TypographyFamilyHeroFontWeightDefault
  },
  textTransform: 'none'
};
const defaultFamilyPrice = {
  fontFamily: TypographyFamilyPriceFontFamily,
  fontWeight: {
    default: TypographyFamilyPriceFontWeightDefault
  },
  textTransform: 'none'
};
const defaultFamilyCaption = {
  fontFamily: TypographyFamilyCaptionFontFamily,
  fontWeight: {
    default: TypographyFamilyCaptionFontWeightDefault,
    regular: TypographyFamilyCaptionFontWeightDefault,
    semiBold: TypographyFamilyCaptionFontWeightSemiBold,
    bold: TypographyFamilyCaptionFontWeightBold
  },
  textTransform: 'none'
}; // Body

const defaultVariantBodyXs = {
  xs: {
    fontSize: '0.75rem',
    // 12px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '0.75rem',
    // 12px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '0.75rem',
    // 12px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  }
};
const defaultVariantBodyS = {
  xs: {
    fontSize: '0.875rem',
    // 14px
    lineHeight: '1.25rem',
    // 20px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '0.875rem',
    // 14px
    lineHeight: '1.25rem',
    // 20px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '0.875rem',
    // 14px
    lineHeight: '1.25rem',
    // 20px
    letterSpacing: 'normal'
  }
};
const defaultVariantBodyM = {
  xs: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  }
};
const defaultVariantBodyL = {
  xs: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.75rem',
    // 28px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.75rem',
    // 28px
    letterSpacing: 'normal'
  }
};
const defaultVariantBodyXl = {
  xs: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.75rem',
    // 28px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.25rem',
    // 20px
    lineHeight: '1.75rem',
    // 28px
    letterSpacing: 'normal'
  }
};
const defaultVariantBody2xl = {
  xs: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.75rem',
    // 28px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.375rem',
    // 22px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  }
};
const defaultVariantBody3xl = {
  xs: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.75rem',
    // 28px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  }
}; // Heading

const defaultVariantHeading2Xs = {
  xs: {
    fontSize: '0.875rem',
    // 14px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '0.875rem',
    // 14px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '0.875rem',
    // 14px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeadingXs = {
  xs: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.25rem',
    // 20px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.25rem',
    // 20px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.25rem',
    // 20px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeadingS = {
  xs: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeadingM = {
  xs: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeadingL = {
  xs: {
    fontSize: '1.75rem',
    // 28px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.75rem',
    // 28px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.75rem',
    // 28px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeadingXl = {
  xs: {
    fontSize: '1.75rem',
    // 28px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '2rem',
    // 32px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '2rem',
    // 32px
    lineHeight: '2.25rem',
    // 36px
    letterSpacing: 'normal'
  }
}; // Hero

const defaultVariantHero2xs = {
  xs: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeroXs = {
  xs: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeroS = {
  xs: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeroM = {
  xs: {
    fontSize: '1.75rem',
    // 28px
    lineHeight: '1.75rem',
    // 28px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '2rem',
    // 32px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '2rem',
    // 32px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeroL = {
  xs: {
    fontSize: '2rem',
    // 32px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '2.25rem',
    // 36px
    lineHeight: '2.25rem',
    // 36px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '2.5rem',
    // 40px
    lineHeight: '2.5rem',
    // 40px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeroXl = {
  xs: {
    fontSize: '2.25rem',
    // 36px
    lineHeight: '2.25rem',
    // 36px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '2.5rem',
    // 40px
    lineHeight: '2.5rem',
    // 40px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '3rem',
    // 48px
    lineHeight: '3rem',
    // 48px
    letterSpacing: 'normal'
  }
};
const defaultVariantHero2xl = {
  xs: {
    fontSize: '2.5rem',
    // 40px
    lineHeight: '2.5rem',
    // 40px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '3rem',
    // 48px
    lineHeight: '3rem',
    // 48px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '3.5rem',
    // 56px
    lineHeight: '3.5rem',
    // 56px
    letterSpacing: 'normal'
  }
};
const defaultVariantHero3xl = {
  xs: {
    fontSize: '2.75rem',
    // 44px
    lineHeight: '2.75rem',
    // 44px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '4.5rem',
    // 56px
    lineHeight: '4.5rem',
    // 56px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '4.5rem',
    // 72px
    lineHeight: '4.5rem',
    // 72px
    letterSpacing: 'normal'
  }
}; // Price

const defaultVariantPrice2xs = {
  xs: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1rem',
    // 16px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1rem',
    // 16px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1rem',
    // 16px
    letterSpacing: 'normal'
  }
};
const defaultVariantPriceXs = {
  xs: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  }
};
const defaultVariantPriceS = {
  xs: {
    fontSize: '1.25rem',
    // 20px
    lineHeight: '1.25rem',
    // 20px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.25rem',
    // 20px
    lineHeight: '1.25rem',
    // 20px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.25rem',
    // 20px
    lineHeight: '1.25rem',
    // 20px
    letterSpacing: 'normal'
  }
};
const defaultVariantPriceM = {
  xs: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  }
};
const defaultVariantPriceL = {
  xs: {
    fontSize: '1.75rem',
    // 28px
    lineHeight: '1.75rem',
    // 28px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '2rem',
    // 32px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '2rem',
    // 32px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  }
};
const defaultVariantPriceXl = {
  xs: {
    fontSize: '2rem',
    // 32px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '2.25rem',
    // 36px
    lineHeight: '2.25rem',
    // 36px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '2.5rem',
    // 40px
    lineHeight: '2.5rem',
    // 40px
    letterSpacing: 'normal'
  }
};
const defaultOverlayTextShadow = '0 2px 4px rgba(0, 0, 0, 0.6)';
const DEFAULT_TYPOGRAPHY = {
  baseFontSize: TypographyBaseFontSize,
  baseLineHeight: TypographyBaseLineHeight,
  lineHeight: defaultLineHeights,
  overlayTextShadow: defaultOverlayTextShadow,
  family: {
    body: defaultFamilyBody,
    heading: defaultFamilyHeading,
    hero: defaultFamilyHero,
    price: defaultFamilyPrice,
    caption: defaultFamilyCaption
  },
  variant: {
    body: {
      xs: defaultVariantBodyXs,
      s: defaultVariantBodyS,
      m: defaultVariantBodyM,
      l: defaultVariantBodyL,
      xl: defaultVariantBodyXl,
      '2xl': defaultVariantBody2xl,
      '3xl': defaultVariantBody3xl
    },
    heading: {
      '2xs': defaultVariantHeading2Xs,
      xs: defaultVariantHeadingXs,
      s: defaultVariantHeadingS,
      m: defaultVariantHeadingM,
      l: defaultVariantHeadingL,
      xl: defaultVariantHeadingXl
    },
    hero: {
      '2xs': defaultVariantHero2xs,
      xs: defaultVariantHeroXs,
      s: defaultVariantHeroS,
      m: defaultVariantHeroM,
      l: defaultVariantHeroL,
      xl: defaultVariantHeroXl,
      '2xl': defaultVariantHero2xl,
      '3xl': defaultVariantHero3xl
    },
    price: {
      '2xs': defaultVariantPrice2xs,
      xs: defaultVariantPriceXs,
      s: defaultVariantPriceS,
      m: defaultVariantPriceM,
      l: defaultVariantPriceL,
      xl: defaultVariantPriceXl
    }
  }
};
export function createTypography(overrides) {
  return deepMerge(DEFAULT_TYPOGRAPHY, overrides);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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